import React from "react";
import Header from "./Components/Header";
import Banner from "./Components/banner";
import { Helmet } from "react-helmet-async";
import Features from "./Components/Featuress";
import Table from "./Components/Table";
import Prizing from "./Components/PricingComponent";
import Testimonial from "./Components/Testimonial";
import HomeVideo from "./Home.mp4";

function HomePage() {
  return (
    <div>
      <Helmet>
        <title>Stock101 Home</title>
        <meta
          name="description"
          content="Welcome to stock 101, a powerful tool for finding the most profitable stocks to buy. Our advanced filtering and 
          sorting criteria together with the real-time news update helps investors determine the most profitable stocks."
        />
        <meta
          name="keywords"
          content="NYSE, Stock Market, Option Based Filter, Zacks Rankings, Prize Targets, Trending News, Technical Indicators"
        />
        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* Header Section */}
      <Header />
      <Banner />
      <Features />
      <Table />

      {/* Video Background Section for Prizing and Testimonials */}
      <div
        style={{
          position: "relative",
          width: "100%",
          minHeight: "100vh", // Full-height container
          overflow: "hidden",
        }}
      >
        {/* Video Background */}
        <video
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: -1, // Behind all content
          }}
        >
          <source src={HomeVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Dark Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.6)", // Semi-transparent dark overlay
            zIndex: 0,
          }}
        ></div>

        {/* Content: Prizing and Testimonials */}
        <div
          style={{
            position: "relative",
            zIndex: 1,
            padding: "40px 20px",
            color: "#fff", // Text color for better visibility
          }}
        >
          <Prizing />
          <Testimonial />
        </div>
      </div>
    </div>
  );
}

export default HomePage;
